import { s as script } from './Timepicker-a6098ce0.mjs';
export { s as OTimepicker } from './Timepicker-a6098ce0.mjs';
import { b as registerComponent } from './plugins-0d853d1f.mjs';
import 'vue';
import './DropdownItem-bf81cb78.mjs';
import './MatchMediaMixin-d91585a4.mjs';
import './config.mjs';
import './helpers.mjs';
import './trapFocus-f32fb08f.mjs';
import './Input-5b84d324.mjs';
import './Icon-e7ad13c9.mjs';
import './FormElementMixin-641da1dc.mjs';
import './Select-2ed6c9d4.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export { index as default };
